<template>
  <div class="goldfish-navbar uk-padding uk-padding-remove-vertical">
    <nav
      class="uk-navbar-container uk-navbar-transparent uk-container"
      uk-navbar
    >
      <template>
        <div
          uk-scrollspy-nav="closest: a;"
          class="goldfish-navbar__chapters"
          v-if="isNorwegian"
        >
          <template v-for="(item, index) in value.Kapitler">
            <a
              :key="'c_' + index"
              class="goldfish-navbar__chapter"
              :href="'#' + slugify(item.Tittel)"
              >{{ item.Tittel }}</a
            >
            <a
              :key="'c_' + index + '_s_' + sindex"
              v-for="(subitem, sindex) in getSubs(item)"
              class="goldfish-navbar__subchapter"
              :href="
                '#' + slugify(item.Tittel) + '-' + slugify(subitem.Undertittel)
              "
              >{{ item.Tittel }} <span>></span>
              <span>{{ subitem.Undertittel }}</span></a
            >
          </template>
        </div>
      </template>
      <template>
        <div
          uk-scrollspy-nav="closest: a;"
          class="goldfish-navbar__chapters"
          v-if="!isNorwegian"
        >
          <template v-for="(item, index) in value.Kapitler">
            <a
              :key="'c_' + index"
              class="goldfish-navbar__chapter"
              :href="'#' + slugify(item.Tittel)"
              >{{ item.Tittel_eng }}</a
            >
            <a
              :key="'c_' + index + '_s_' + sindex"
              v-for="(subitem, sindex) in getSubs(item)"
              class="goldfish-navbar__subchapter"
              :href="
                '#' + slugify(item.Tittel) + '-' + slugify(subitem.Undertittel)
              "
              >{{ item.Tittel_eng }} <span>></span>
              <span>{{ subitem.Undertittel_eng }}</span></a
            >
          </template>
        </div>
      </template>
      <div style="margin-left: auto" class="goldfish-navbar__buttons">
        <button
          class="uk-button uk-button-primary goldfish-navbar__button-prev"
          @click="navigate(-1)"
        >
          <span class="uk-visible@s">
            {{ $t("components.navigation.prev") }}
          </span>
        </button>
        <button
          class="uk-button uk-button-primary goldfish-navbar__button-next"
          @click="navigate(1)"
        >
          <span class="uk-visible@s">
            {{ $t("components.navigation.next") }}
          </span>
        </button>
        <DropdownComponent>
          <template #default>
            <button class="uk-button uk-button-secondary">•••</button>
          </template>
          <template #dropdown>
            <div class="dropdown-wrap">
              <TOC :chapters="value.Kapitler" />
            </div>
          </template>
        </DropdownComponent>
        <Switcher />
      </div>
    </nav>
  </div>
</template>

<script>
import { Slugify as slugify } from "@/utils";
import { DropdownComponent } from "vue-elder-dropdown";
import Switcher from "@/components/Switcher.vue";
import TOC from "@/components/TOC";

function scrollToTarget(element) {
  if (!element) return;
  let offset = 1;
  let elementPosition = element.getBoundingClientRect().top;
  let offsetPosition = window.pageYOffset + elementPosition + offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
}

export default {
  props: {
    value: Object,
  },
  methods: {
    getSubs(item) {
      return item.kapittel.blocks.filter(
        (b) => b.__typename === "ComponentElementUndertittel"
      );
    },
    navigate(delta) {
      let el = this.$el.querySelector(".uk-active");

      let target = delta > 0 ? el.nextSibling : el.previousSibling;
      if (!target) return;

      scrollToTarget(document.querySelector(target.hash));
    },
    slugify,
  },
  computed: {
    isNorwegian() {
      if (this.$i18n.locale == "no") {
        return true;
      }
    },
  },
  components: {
    DropdownComponent,
    TOC,
    Switcher,
  },
};
</script>

<style lang="scss" scoped>
.goldfish-navbar {
  background-color: rgba($color: #e5e5e5, $alpha: 0.8);
  position: sticky;
  top: 0;
  z-index: 999;

  &__chapter,
  &__subchapter {
    display: none;
    font-size: 0.9em;

    span {
      font-weight: 300;
      margin: 0 0.25rem;
    }

    &.uk-active {
      display: block;
    }
  }

  &__chapters {
    overflow: hidden;
    white-space: nowrap;
    margin-right: 1rem;
  }

  @media (max-width: 700px) {
    .dropdown-wrap {
      max-height: 80vh;
      overflow: auto;
    }
  }

  .uk-button {
    text-transform: capitalize;
    padding: 0.3rem 0.5rem;
    line-height: 1;

    &-primary {
      background-color: #808080;
    }
    &-secondary {
      background-color: #ff9e3c;
    }
  }

  &__buttons {
    display: flex;
    align-items: center;
  }

  &__button {
    &-next {
      &:after {
        content: " >";

        @media (max-width: $mobile) {
          content: ">";
        }
      }
    }
    &-prev {
      &:before {
        content: "< ";
        @media (max-width: $mobile) {
          content: "<";
        }
      }
    }
  }

  .toc {
    padding: 2rem;
    width: 1024px;
    max-width: 100%;
    overflow: auto;
    max-height: 80vh;
  }

  .uk-navbar-container {
    display: flex;

    align-items: center;
    padding: 1rem 0;

    button + button,
    button + .elder-dropdown {
      margin-left: 1rem;
    }

    a {
      text-transform: capitalize;
      font-weight: bold;
      color: #666666;
      white-space: initial;
    }
  }
}
</style>
